/* eslint-disable no-nested-ternary */
import React, { Component } from 'react';
import { Container, Row, Col, Button } from 'reactstrap';
import DateTimePicker from 'react-widgets/lib/DateTimePicker';
import momentLocalizer from 'react-widgets-moment';
import { connect } from 'react-redux';
import Select from 'react-select';
import moment from 'moment';
import { getAllPets } from '../../services/Pets/actions';
import { CustomLoading } from '../../components/Loading';
import PetListTable from '../../components/PetList';
import { returnAllBreeds } from '../../components/BreedList';
import 'react-widgets/dist/css/react-widgets.css';

momentLocalizer();
class PetList extends Component {
  state = {
    selectedOption: null,
    tempLoading: true,
  };

  componentDidMount() {
    this.props.getAllPets(() => {
      this.setState({
        tempLoading: false,
        tempPetList: this.props.Pets.petList,
        backupPetList: this.props.Pets.petList,
      });
    });
  }

  openClient = (clientId) => {
    this.props.history.push(`/client/${clientId}`);
  }

  sortList = () => {
    const {
      backupPetList,
      selectedBreed,
      selectedGender,
      selectedType,
      vaccToDate,
      vaccFromDate,
    } = this.state;

    let holdingPetList = backupPetList;
    if (selectedBreed) {
      holdingPetList = holdingPetList.filter(item => item.breed.label === selectedBreed);
    }
    if (selectedGender) {
      holdingPetList = holdingPetList.filter(item => item.gender === selectedGender);
    }
    if (selectedType) {
      holdingPetList = holdingPetList.filter(item => item.type.label === selectedType);
    }
    if (vaccFromDate && vaccToDate) {
      holdingPetList = holdingPetList.filter((item) => {
        let exists = false;
        if (item.lastVaccination) {
          for (let j = 0; j < item.lastVaccination.length; j++) {
            const teasdasd = moment.unix(item.lastVaccination[j].seconds).format('DD/MM/YYYY');
            if (moment(teasdasd, 'DD/MM/YYYY').isBetween(moment(vaccFromDate), moment(vaccToDate))) {
              exists = true;
            }
          }
        }
        if (exists) {
          return item;
        }
        return null;
      });
    }
    this.setState({
      tempPetList: holdingPetList,
    });
  }

  clearDateValues = () => {
    this.setState({
      vaccFromDate: undefined,
      vaccToDate: undefined,
    }, () => {
      this.sortList();
    });
  }

   handleChange = (selectedOption) => {
     this.setState(
       { selectedOption },
       () => {
         this.props.history.push(`/pet/${this.state.selectedOption.value}`);
       },
     );
   };

   handleTypeChange = (selectedOption) => {
     if (selectedOption) {
       this.setState({
         selectedType: selectedOption.label,
       }, () => {
         this.sortList();
       });
     } else {
       this.setState({
         selectedType: null,
       }, () => {
         this.sortList();
       });
     }
   };

  handleBreedChange = (selectedOption) => {
    if (selectedOption) {
      this.setState({
        selectedBreed: selectedOption.label,
      }, () => {
        this.sortList();
      });
    } else {
      this.setState({
        selectedBreed: null,
      }, () => {
        this.sortList();
      });
    }
  };

  handleGenderChange = (selectedOption) => {
    if (selectedOption) {
      this.setState({
        selectedGender: selectedOption.label,
      }, () => {
        this.sortList();
      });
    } else {
      this.setState({
        selectedGender: null,
      }, () => {
        this.sortList();
      });
    }
  }

  handleVaccFromDateChange = (date) => {
    if (date) {
      this.setState({
        vaccFromDate: date,
      }, () => {
        this.sortList();
      });
    } else {
      this.setState({
        vaccFromDate: null,
      }, () => {
        this.sortList();
      });
    }
  }

  handleVaccToDateChange = (date) => {
    if (date) {
      this.setState({
        vaccToDate: date,
      }, () => {
        this.sortList();
      });
    } else {
      this.setState({
        vaccToDate: null,
      }, () => {
        this.sortList();
      });
    }
  }

  render() {
    const {
      Pets: {
        isLoading,
      },
    } = this.props;

    const {
      tempLoading,
      tempPetList,
      vaccToDate,
      vaccFromDate,
    } = this.state;

    if (isLoading || tempLoading) {
      return (
        <CustomLoading />
      );
    }

    return (
      <Container>
        <Row className="mt-3">
          <Col sm="12" md="4">
            <Select
              onChange={this.handleTypeChange}
              isClearable="true"
              options={[
                {
                  label: 'Canine',
                  value: 1,
                },
                {
                  label: 'Feline',
                  value: 2,
                },
                {
                  label: 'Other',
                  value: 3,
                },
              ]}
              placeholder="Select Type"
            />
          </Col>
          <Col sm="12" md="4">
            <Select
              onChange={this.handleBreedChange}
              options={returnAllBreeds()}
              placeholder="Select Breed"
              isClearable="true"
            />
          </Col>
          <Col sm="12" md="4">
            <Select
              onChange={this.handleGenderChange}
              isClearable="true"
              options={[
                {
                  label: 'male',
                  value: 1,
                },
                {
                  label: 'female',
                  value: 2,
                },
              ]}
              placeholder="Select Gender"
            />
          </Col>
        </Row>

        <Row className="mt-3">
          <Col sm="12">
            Vaccination Selection
            <Button color="danger" onClick={this.clearDateValues}> Clear dates</Button>
          </Col>
          <Col sm="12" md="6">
            From date
            <DateTimePicker
              onChange={this.handleVaccFromDateChange}
              format="DD MMM YYYY"
              time={false}
              value={vaccFromDate ? new Date(vaccFromDate) : new Date(moment().subtract(1, 'years'))}
            />
          </Col>
          <Col sm="12" md="6">
            To date
            <DateTimePicker
              onChange={this.handleVaccToDateChange}
              format="DD MMM YYYY"
              time={false}
              value={vaccToDate ? new Date(vaccToDate) : new Date(moment().subtract(1, 'years'))}
            />
          </Col>
        </Row>
        <Row className="mt-3">
          <Col sm="12">
            <PetListTable
              petList={tempPetList}
              isLoading={isLoading}
              openClient={this.openClient}
            />
          </Col>
        </Row>
      </Container>
    );
  }
}

const mapStateToProps = state => ({
  Pets: state.Pets,
});

const mapDispatchToProps = {
  getAllPets,
};

export default connect(mapStateToProps, mapDispatchToProps)(PetList);
